import SourceMaterialManagement from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'source-material-management',
  title: '素材管理',
  version: '0.1.29',
  description: '素材管理',
  routes: SourceMaterialManagement, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: ['DirectoryApi', 'MaterialApi', 'FileApi', 'TempFileApi'],
  },
  config: {
    currentEnv: {
      chartletSize: 30,
    },
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
